<p>
    <button
        title="Select All"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedContractors = items"
        label="Select All"
    ></button>
</p>
<p>
    <button
        title="Select None"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedContractors = []"
        label="Select None"
    ></button>
</p>
<p>
    <p-tree
        [filter]="true"
        filterMode="strict"
        filterPlaceholder="Search for user"
        #contractorTree
        [value]="items"
        selectionMode="checkbox"
        [(selection)]="selectedContractors"
        scrollHeight="flex"
    ></p-tree>
</p>
<p>
    <button
        title="Send Bills"
        pButton
        pRipple
        severity="primary"
        icon="pi pi-send"
        type="button"
        (click)="SendBills.next(contractorTree.selection)"
        label="Send Bills"
    ></button>
</p>
